const baseURL = process.env.REACT_APP_BASE_URL + 'cas/';

async function loadJson(data, urlPath) {
  try {
    const response = await fetch(baseURL + urlPath + '.php', {
      method: 'POST',
      body: data,
    });
    const resp = await response.text();
    if (resp !== 'INVALID') {
      try {
        return JSON.parse(resp);
      } catch {
        return resp;
      }
    }
    return 'INVALID';
  } catch (error) {
    console.error('cas_services:', error);
    return null;
  }
}

/**
 * @param {string} token
 * @returns {Promise<Array<{id:number,name:string}>|'INVALID'|null>}
 */
export async function list_root_materials(token) {
  const data = new FormData();
  data.append('token', token);
  return loadJson(data, 'get/list_root_materials');
}

/**
 * @param {string} token
 * @param {string} name
 * @param {string} [description]
 * @param {string} [cost] precio USD como texto (opcional)
 * @returns {Promise<{ok:boolean,id?:number,name?:string,description?:string|null,cost?:number|null,error?:string}|'INVALID'|null>}
 */
export async function create_root_material(token, name, description, cost) {
  const data = new FormData();
  data.append('token', token);
  data.append('name', name);
  data.append('description', description ?? '');
  data.append('cost', cost ?? '');
  return loadJson(data, 'set/create_root_material');
}

/**
 * @param {string} token
 * @param {string|number} rootMaterialId
 * @returns {Promise<{ok:boolean,id?:number,name?:string,description?:string|null,cost?:number|null,error?:string}|'INVALID'|null>}
 */
export async function load_root_material(token, rootMaterialId) {
  const data = new FormData();
  data.append('token', token);
  data.append('root_material_id', String(rootMaterialId));
  return loadJson(data, 'get/load_root_material');
}

/**
 * @returns {Promise<{ok:boolean,id?:number,name?:string,error?:string}|'INVALID'|null>}
 */
export async function update_root_material(token, rootMaterialId, name, description, cost) {
  const data = new FormData();
  data.append('token', token);
  data.append('root_material_id', String(rootMaterialId));
  data.append('name', name);
  data.append('description', description ?? '');
  data.append('cost', cost ?? '');
  return loadJson(data, 'set/update_root_material');
}

/**
 * @returns {Promise<{ok:boolean,id?:number,error?:string}|'INVALID'|null>}
 */
export async function delete_root_material(token, rootMaterialId) {
  const data = new FormData();
  data.append('token', token);
  data.append('root_material_id', String(rootMaterialId));
  return loadJson(data, 'set/delete_root_material');
}

/**
 * Movimiento de inventario tipo "in" (type=0).
 * @param {string} token
 * @param {string|number} channelId
 * @param {string|number} rootMaterialsId id en root_materials
 * @param {number} qty cantidad entera >= 1
 * @param {string} [ref]
 * @param {string} [description]
 * @returns {Promise<{ok:boolean,id?:number,error?:string}|'INVALID'|null>}
 */
export async function insert_root_materials_inventory_movement(
  token,
  channelId,
  rootMaterialsId,
  qty,
  ref,
  description,
  issueId,
  type
) {
  const data = new FormData();
  data.append('token', token);
  data.append('channel_id', String(channelId));
  data.append('root_materials_id', String(rootMaterialsId));
  data.append('qty', String(qty));
  data.append('ref', ref ?? '');
  data.append('description', description ?? '');
  data.append('issue_id', issueId == null ? '' : String(issueId));
  data.append('type', type == null ? '0' : String(type));
  return loadJson(data, 'set/insert_root_materials_inventory');
}

/**
 * Lista movimientos CAS asociados a un ticket.
 * @returns {Promise<Array<{id:number,root_material_name:string,qty:number,date_time:string|null,usr_name:string|null,type:number,ref:string|null,description:string|null}>|'INVALID'|null>}
 */
export async function load_issue_inventory_movements(token, issueId) {
  const data = new FormData();
  data.append('token', token);
  data.append('issue_id', String(issueId));
  return loadJson(data, 'get/load_issue_inventory_movements');
}

/**
 * Elimina un movimiento CAS por id.
 * @returns {Promise<{ok:boolean,id?:number,error?:string,debug?:object}|'INVALID'|null>}
 */
export async function delete_root_material_inventory_movement(token, movementId) {
  const data = new FormData();
  data.append('token', token);
  data.append('movement_id', String(movementId));
  return loadJson(data, 'set/delete_root_material_inventory_movement');
}

/**
 * Consolidado de inventario por producto para un canal CAS.
 * @returns {Promise<Array<{root_material_id:number,root_material_name:string,qty_balance:number,movements_count:number,last_movement_at:string|null}>|'INVALID'|null>}
 */
export async function list_root_materials_inventory_consolidated(token, channelId) {
  const data = new FormData();
  data.append('token', token);
  data.append('channel_id', String(channelId));
  return loadJson(data, 'get/list_root_materials_inventory_consolidated');
}

/**
 * Detalle de movimientos de un producto en un canal CAS.
 * @returns {Promise<Array<{id:number,qty:number,ref:string|null,description:string|null,date_time:string|null,usr_name:string|null,type:number}>|'INVALID'|null>}
 */
export async function load_root_material_inventory_movements(
  token,
  channelId,
  rootMaterialId
) {
  const data = new FormData();
  data.append('token', token);
  data.append('channel_id', String(channelId));
  data.append('root_material_id', String(rootMaterialId));
  return loadJson(data, 'get/load_root_material_inventory_movements');
}
